/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
define(["require", "exports", "azure-devops-ui/ConditionalChildren", "azure-devops-ui/Core/Observable", "azure-devops-ui/Core/Util/String", "azure-devops-ui/Dropdown", "azure-devops-ui/Header", "azure-devops-ui/HeaderCommandBar", "azure-devops-ui/Page", "azure-devops-ui/Spinner", "azure-devops-ui/Surface", "azure-devops-ui/Tabs", "azure-devops-ui/Utilities/DropdownSelection", "azure-devops-ui/Utilities/Filter", "history", "react", "simple-query-string", "azure-devops-ui/Link", "azure-devops-ui/TooltipEx", "../../Contracts/Contracts", "../../Resources", "../Constants", "../FluxCommon/ActionsCreatorManager", "../FluxCommon/StoreManager", "../ImageDetails/ImageDetails", "../KubeFactory", "../Pods/PodsDetails", "../Pods/PodsRightPanel", "../Pods/PodsStore", "../Selection/SelectionActionCreator", "../Selection/SelectionStore", "../Services/ServiceDetails", "../Services/ServicesActionsCreator", "../Services/ServicesPivot", "../Services/ServicesStore", "../Services/ServiceUtils", "../Utils", "../Workloads/WorkloadDetails", "../Workloads/WorkloadsActionsCreator", "../Workloads/WorkloadsPivot", "../Workloads/WorkloadsStore", "./KubeConsumer", "./KubeZeroData", "./KubeSummary.scss"], function (require, exports, ConditionalChildren_1, Observable_1, String_1, Dropdown_1, Header_1, HeaderCommandBar_1, Page_1, Spinner_1, Surface_1, Tabs_1, DropdownSelection_1, Filter_1, history_1, React, queryString, Link_1, TooltipEx_1, Contracts_1, Resources, Constants_1, ActionsCreatorManager_1, StoreManager_1, ImageDetails_1, KubeFactory_1, PodsDetails_1, PodsRightPanel_1, PodsStore_1, SelectionActionCreator_1, SelectionStore_1, ServiceDetails_1, ServicesActionsCreator_1, ServicesPivot_1, ServicesStore_1, ServiceUtils_1, Utils_1, WorkloadDetails_1, WorkloadsActionsCreator_1, WorkloadsPivot_1, WorkloadsStore_1, KubeConsumer_1, KubeZeroData_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var workloadsPivotItemKey = "workloads";
    var servicesPivotItemKey = "services";
    var workloadsFilterToggled = new Observable_1.ObservableValue(false);
    var servicesFilterToggled = new Observable_1.ObservableValue(false);
    var KubeSummary = /** @class */ (function (_super) {
        __extends(KubeSummary, _super);
        function KubeSummary(props) {
            var _this = _super.call(this, props, {}) || this;
            _this._updateStateFromHistory = function (routeValues) {
                if (routeValues["type"] && routeValues["uid"]) {
                    var typeName = routeValues["type"];
                    var objectId = routeValues["uid"];
                    var selectedItem = _this._objectFinder[typeName](objectId);
                    _this.setState({ selectedItemType: typeName, selectedItem: selectedItem, showSelectedItem: true, selectedItemUid: objectId, selectedItemProperties: routeValues });
                }
                else {
                    if (_this.props.onViewChanged) {
                        _this.props.onViewChanged([]);
                    }
                    _this.setState({
                        selectedItemType: "",
                        selectedItem: undefined,
                        showSelectedItem: false,
                        selectedItemUid: undefined
                    });
                }
            };
            _this._onHistoryChanged = function (location, action) {
                _this._updateStateFromHistory(queryString.parse(location.search));
            };
            _this._setNamespaceOnDeploymentsFetched = function () {
                if (!_this.state.namespace) {
                    var workloadStoreState = _this._workloadsStore.getState();
                    _this.setState({ namespace: workloadStoreState.deploymentNamespace });
                }
            };
            _this._onZeroDeploymentsFound = function () {
                _this.setState({ zeroDeploymentsFound: true });
            };
            _this._onWorkloadsFilterApplied = function (currentState) {
                _this.setState({});
            };
            _this._onSvcFilterApplied = function (currentState) {
                _this.setState({});
            };
            _this._onDataFound = function () {
                var workloadSize = _this._workloadsStore.getWorkloadSize();
                var servicesSize = _this._servicesStore.getServicesSize();
                var resourceSize = workloadSize + servicesSize;
                if (_this.state.resourceSize <= 0 && resourceSize > 0) {
                    _this.setState({ resourceSize: resourceSize });
                }
            };
            _this._onSelectionStoreChanged = function () {
                var selectionStoreState = _this._selectionStore.getState();
                if (!selectionStoreState.showSelectedItem && _this.props.onViewChanged) {
                    _this.props.onViewChanged([]);
                }
                var setStateWithSelection = function (item) {
                    _this.setState({
                        showSelectedItem: selectionStoreState.showSelectedItem,
                        selectedItem: item,
                        selectedItemType: selectionStoreState.selectedItemType,
                        selectedItemUid: selectionStoreState.itemUID,
                        selectedItemProperties: selectionStoreState.properties
                    });
                };
                // If the selection only has id and doesn't have the item, we would need to fetch the item
                if (!!selectionStoreState.itemUID && !selectionStoreState.selectedItem) {
                    var invokedFunc = undefined;
                    var item_1 = undefined;
                    var getMatchingItem = function (items) {
                        if (items && items.length) {
                            return items.find(function (r) { return r.metadata.uid === selectionStoreState.itemUID; });
                        }
                    };
                    var kubeService_1 = KubeFactory_1.KubeFactory.getKubeService();
                    switch (selectionStoreState.selectedItemType) {
                        case "replica-set" /* ReplicaSetKey */:
                            var replicaSets = _this._workloadsStore.getState().replicaSetList;
                            if (replicaSets) {
                                item_1 = getMatchingItem(replicaSets.items);
                            }
                            if (!item_1) {
                                invokedFunc = function () { return kubeService_1.getReplicaSets(); };
                            }
                            break;
                        case "stateful-set" /* StatefulSetKey */:
                            var statefulSets = _this._workloadsStore.getState().statefulSetList;
                            if (statefulSets) {
                                item_1 = getMatchingItem(statefulSets.items);
                            }
                            if (!item_1) {
                                invokedFunc = function () { return kubeService_1.getStatefulSets(); };
                            }
                            break;
                        case "daemon-set" /* DaemonSetKey */:
                            var daemonSets = _this._workloadsStore.getState().daemonSetList;
                            if (daemonSets) {
                                item_1 = getMatchingItem(daemonSets.items);
                            }
                            if (!item_1) {
                                invokedFunc = function () { return kubeService_1.getDaemonSets(); };
                            }
                            break;
                    }
                    if (invokedFunc) {
                        invokedFunc().then(function (list) {
                            // If the selection has been modified while this promise was being resolved, don't do anything
                            if (selectionStoreState.itemUID !== _this._selectionStore.getState().itemUID) {
                                return;
                            }
                            if (list && list.items && list.items.length) {
                                item_1 = list.items.find(function (i) { return i.metadata.uid === selectionStoreState.itemUID; });
                            }
                            if (item_1) {
                                setStateWithSelection(item_1);
                            }
                        });
                    }
                    else {
                        setStateWithSelection(item_1);
                    }
                }
                else {
                    setStateWithSelection(selectionStoreState.selectedItem);
                }
            };
            _this._setSelectedKeyPodsViewMap = function () {
                _this._selectedItemViewMap["replica-set" /* ReplicaSetKey */] = function (item) { return _this._getWorkloadPodsViewComponent(item, "ReplicaSet", "replica-set" /* ReplicaSetKey */, function (item) {
                    var status = item.status;
                    return Utils_1.Utils.getPodsStatusProps(status.readyReplicas, status.replicas);
                }); };
                _this._selectedItemViewMap["stateful-set" /* StatefulSetKey */] = function (item) { return _this._getWorkloadPodsViewComponent(item, "StatefulSet", "stateful-set" /* StatefulSetKey */, function (item) {
                    var status = item.status;
                    return Utils_1.Utils.getPodsStatusProps(status.readyReplicas, status.replicas);
                }); };
                _this._selectedItemViewMap["daemon-set" /* DaemonSetKey */] = function (item) { return _this._getWorkloadPodsViewComponent(item, "DaemonSet", "daemon-set" /* DaemonSetKey */, function (item) {
                    var status = item.status;
                    return Utils_1.Utils.getPodsStatusProps(status.numberAvailable, status.desiredNumberScheduled);
                }); };
                _this._selectedItemViewMap["orphan-pod" /* OrphanPodKey */] = function (pod, uid) {
                    var _a = pod ? Utils_1.Utils.generatePodStatusProps(pod.status) : { statusProps: undefined, tooltip: undefined }, statusProps = _a.statusProps, tooltip = _a.tooltip;
                    return React.createElement(PodsRightPanel_1.PodsRightPanel, { pod: pod, podStatusProps: statusProps, statusTooltip: tooltip, podUid: uid });
                };
                _this._selectedItemViewMap["service-item" /* ServiceItemKey */] = function (service) { return React.createElement(ServiceDetails_1.ServiceDetails, { service: service, parentKind: (service && service.kind) || "Service", notifyViewChanged: _this.props.onViewChanged }); };
                _this._selectedItemViewMap["image-details" /* ImageDetailsKey */] = function (item) { return React.createElement(ImageDetails_1.ImageDetails, { imageDetails: item, onBackButtonClick: _this._setSelectionStateFalse }); };
                _this._selectedItemViewMap["pod-details" /* PodDetailsKey */] = function (item, uid, properties) { return _this._getPodDetailsComponent(uid, properties); };
            };
            _this._setSelectionStateFalse = function () {
                var payload = {
                    item: undefined,
                    itemUID: "",
                    showSelectedItem: false,
                    selectedItemType: ""
                };
                _this._selectionActionCreator.selectItem(payload);
            };
            _this._namespaceSelection = new DropdownSelection_1.DropdownSelection();
            _this._selectedItemViewMap = {};
            _this._objectFinder = {};
            _this._initializeFactorySettings();
            var workloadsFilter = new Filter_1.Filter();
            var servicesFilter = new Filter_1.Filter();
            workloadsFilter.subscribe(_this._onWorkloadsFilterApplied, Filter_1.FILTER_CHANGE_EVENT);
            servicesFilter.subscribe(_this._onSvcFilterApplied, Filter_1.FILTER_CHANGE_EVENT);
            _this._setSelectedKeyPodsViewMap();
            _this._populateObjectFinder();
            _this._historyService = history_1.createBrowserHistory();
            var queryParams = queryString.parse(_this._historyService.location.search);
            var selectedPivot = workloadsPivotItemKey;
            // If type is not present, and view is present, load corresponding tab
            if (!queryParams.type && !!queryParams.view) {
                selectedPivot = queryParams.view;
            }
            // Take namespace from deployment store and rest from selection store
            _this.state = {
                namespace: _this.props.namespace || "",
                selectedPivotKey: selectedPivot,
                showSelectedItem: queryParams.uid ? true : false,
                selectedItemUid: queryParams.uid,
                selectedItemProperties: queryParams,
                selectedItem: undefined,
                selectedItemType: queryParams.type || "",
                resourceSize: 0,
                svcFilter: servicesFilter,
                workloadsFilter: workloadsFilter,
                resourceErrorType: _this._getResourceErrorType(),
                zeroDeploymentsFound: false
            };
            _this._servicesStore = StoreManager_1.StoreManager.GetStore(ServicesStore_1.ServicesStore);
            _this._selectionStore = StoreManager_1.StoreManager.GetStore(SelectionStore_1.SelectionStore);
            // ensure workload store is created before get Deployments action
            _this._workloadsStore = StoreManager_1.StoreManager.GetStore(WorkloadsStore_1.WorkloadsStore);
            _this._podsStore = StoreManager_1.StoreManager.GetStore(PodsStore_1.PodsStore);
            _this._workloadsActionCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(WorkloadsActionsCreator_1.WorkloadsActionsCreator);
            _this._selectionActionCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(SelectionActionCreator_1.SelectionActionsCreator);
            _this._workloadsStore.addListener(Constants_1.WorkloadsEvents.DeploymentsFetchedEvent, _this._setNamespaceOnDeploymentsFetched);
            _this._workloadsStore.addListener(Constants_1.WorkloadsEvents.WorkloadsFoundEvent, _this._onDataFound);
            _this._workloadsStore.addListener(Constants_1.WorkloadsEvents.ZeroDeploymentsFoundEvent, _this._onZeroDeploymentsFound);
            _this._servicesStore.addListener(Constants_1.ServicesEvents.ServicesFoundEvent, _this._onDataFound);
            _this._selectionStore.addChangedListener(_this._onSelectionStoreChanged);
            var kubeService = KubeFactory_1.KubeFactory.getKubeService();
            // fetch deployments in parent component
            // so we can show nameSpace in heading and namespace is obtained from deployment metadata
            // this data also helpful in deciding to show zero data or workloads
            _this._workloadsActionCreator.getDeployments(kubeService);
            if (selectedPivot === servicesPivotItemKey) {
                ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(ServicesActionsCreator_1.ServicesActionsCreator).getServices(kubeService);
            }
            return _this;
        }
        KubeSummary.prototype.render = function () {
            return (React.createElement(Surface_1.Surface, { background: 1 /* neutral */ },
                React.createElement(Page_1.Page, { className: "kubernetes-container flex flex-grow" }, this.state.showSelectedItem ?
                    this._getSelectedItemPodsView() :
                    this._getMainContent())));
        };
        KubeSummary.prototype.componentDidMount = function () {
            var _this = this;
            // this needs to be called after the data is loaded so that we can decide which object is selected as per the URL
            setTimeout(function () {
                _this._updateStateFromHistory(queryString.parse(_this._historyService.location.search));
                _this._historyUnlisten = _this._historyService.listen(_this._onHistoryChanged);
            }, 100);
        };
        KubeSummary.prototype.componentDidUpdate = function (prevProps, prevState) {
            // When selected pivot is workloads but deployments do not exist, then fetch services.
            if (this.state.resourceSize <= 0 && this.state.zeroDeploymentsFound && this.state.selectedPivotKey === workloadsPivotItemKey) {
                var kubeService = KubeFactory_1.KubeFactory.getKubeService();
                ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(ServicesActionsCreator_1.ServicesActionsCreator).getServices(kubeService);
            }
        };
        KubeSummary.prototype.componentWillUnmount = function () {
            this._historyUnlisten();
            this._workloadsStore.removeListener(Constants_1.WorkloadsEvents.DeploymentsFetchedEvent, this._setNamespaceOnDeploymentsFetched);
            this._workloadsStore.removeListener(Constants_1.WorkloadsEvents.WorkloadsFoundEvent, this._onDataFound);
            this._servicesStore.removeListener(Constants_1.ServicesEvents.ServicesFoundEvent, this._onDataFound);
            this._selectionStore.removeChangedListener(this._onSelectionStoreChanged);
            this._workloadsStore.removeListener(Constants_1.WorkloadsEvents.ZeroDeploymentsFoundEvent, this._onZeroDeploymentsFound);
        };
        KubeSummary.prototype._getResourceErrorType = function () {
            var _this = this;
            if (!this.props.getResourceErrorType) {
                return Contracts_1.ResourceErrorType.None;
            }
            var resourceFn = this.props.getResourceErrorType();
            var resourcePromise = resourceFn;
            if (resourcePromise && resourcePromise.then) {
                setTimeout(function () {
                    // if the prop is promise, materialize the promise little later
                    resourcePromise.then(function (errorType) { _this.setState({ resourceErrorType: errorType }); });
                }, 0);
                return Contracts_1.ResourceErrorType.NotInitialized;
            }
            return resourceFn;
        };
        KubeSummary.prototype._getMainContent = function () {
            var pageContent = this._getPageContent();
            var cmdBarItemsFn = this.props.summaryPageHeaderCommandItems;
            var headerProps = {
                title: this.props.title,
                titleSize: 1 /* Large */,
                className: "content-main-heading",
                description: this._getHeaderDescriptionComponent(),
                commandBarItems: cmdBarItemsFn && cmdBarItemsFn({ resourceErrorType: this.state.resourceErrorType })
            };
            if (this.props.onTitleBackClick) {
                headerProps.backButtonProps = { subtle: true, iconProps: { iconName: "Back" }, onClick: this.props.onTitleBackClick, className: "cursor-pointer" };
            }
            return (React.createElement(React.Fragment, null,
                React.createElement(Header_1.Header, __assign({}, headerProps)),
                pageContent));
        };
        KubeSummary.prototype._getHeaderDescriptionComponent = function () {
            var _this = this;
            var namespaceText = this.state.namespace || queryString.parse(this._historyService.location.search)["namespace"] || "";
            // set dropdown value to the selected namespace
            var availableNamespaces = this.props.namespaces || [];
            var namespaceIndexToSelect = availableNamespaces.findIndex(function (name) { return name === namespaceText; });
            namespaceIndexToSelect = namespaceIndexToSelect < 0 ? 0 : namespaceIndexToSelect;
            this._namespaceSelection.select(namespaceIndexToSelect);
            // show cluster if available, and show namespace only if namespaces list is not available
            return (React.createElement("div", { className: "flex-column rhythm-vertical-8" },
                /* show clustername always if it is available */
                this._getHeaderClusterNameComponent(),
                /* show namespaces always if they are available */
                availableNamespaces.length > 0 &&
                    React.createElement("div", { className: "flex-row flex-center rhythm-horizontal-8" },
                        React.createElement("div", null, Resources.NamespaceLabelText),
                        React.createElement(Dropdown_1.Dropdown, { className: "k8s-namespaces-dropdown", selection: this._namespaceSelection, items: availableNamespaces.map(function (name) { return { id: name, text: name }; }), onSelect: function (event, item) {
                                // update namespace in url, when namespace is changed
                                var newNamespace = item && item.text || _this.state.namespace || "";
                                var routeValues = __assign({}, queryString.parse(_this._historyService.location.search), { namespace: newNamespace });
                                _this._historyService.replace({
                                    pathname: _this._historyService.location.pathname,
                                    search: queryString.stringify(routeValues)
                                });
                                // refresh the page
                                _this._historyService.go(0);
                            } })),
                /* show namespace only if clustername is not available or namespaces list not set */
                !this.props.clusterName && availableNamespaces.length <= 0 &&
                    React.createElement("div", { className: "flex-row flex-center rhythm-horizontal-8" },
                        React.createElement("div", null, Resources.NamespaceLabelText),
                        React.createElement("div", null, namespaceText))));
        };
        KubeSummary.prototype._getHeaderClusterNameComponent = function () {
            // show clustername always if it is available
            if (this.props.clusterName) {
                return this.props.clusterUrl ?
                    React.createElement(Link_1.Link, { href: this.props.clusterUrl, target: "_blank", rel: "nofollow noopener" }, String_1.localeFormat(Resources.SummaryHeaderSubTextFormat, this.props.clusterName))
                    : React.createElement(TooltipEx_1.Tooltip, { text: Resources.ClusterLinkHelpText },
                        React.createElement("div", null, String_1.localeFormat(Resources.SummaryHeaderSubTextFormat, this.props.clusterName)));
            }
            return null;
        };
        KubeSummary.prototype._getPageContent = function () {
            // show spinner till we know there are no error scenarios
            switch (this.state.resourceErrorType) {
                case Contracts_1.ResourceErrorType.NotInitialized:
                    return React.createElement(Spinner_1.Spinner, { className: "flex flex-grow", size: "large" /* large */, label: Resources.LoadingText });
                case Contracts_1.ResourceErrorType.AccessDenied:
                case Contracts_1.ResourceErrorType.Deleted:
                    return this._getResourceErrorComponent();
                default:
                    return this.state.resourceSize > 0 ? this._getMainPivot() : this._getZeroData();
            }
        };
        KubeSummary.prototype._getResourceErrorComponent = function () {
            var errorType = this.state.resourceErrorType;
            if (this.props.getResourceErrorActionComponent) {
                return this.props.getResourceErrorActionComponent({ resourceErrorType: errorType });
            }
            switch (errorType) {
                case Contracts_1.ResourceErrorType.Deleted:
                    return KubeZeroData_1.KubeZeroData.getResourceDeletedErrorComponent();
                case Contracts_1.ResourceErrorType.AccessDenied:
                    return KubeZeroData_1.KubeZeroData.getResourceAccessDeniedErrorComponent();
            }
            return undefined;
        };
        KubeSummary.prototype._getMainPivot = function () {
            var _this = this;
            var commonProps = {
                kubeService: this.props.kubeService,
                namespace: this.state.namespace
            };
            var tabContent = this.state.selectedPivotKey === servicesPivotItemKey
                ? React.createElement(ServicesPivot_1.ServicesPivot, __assign({}, commonProps, { filter: this.state.svcFilter, filterToggled: servicesFilterToggled }))
                : React.createElement(WorkloadsPivot_1.WorkloadsPivot, __assign({}, commonProps, { filter: this.state.workloadsFilter, filterToggled: workloadsFilterToggled }));
            // must be short syntax or React.Fragment, do not use div here to include heading and content.
            return (React.createElement(React.Fragment, null,
                React.createElement(Tabs_1.TabBar, { selectedTabId: this.state.selectedPivotKey || workloadsPivotItemKey, onSelectedTabChanged: function (key) { _this._selectTab(key); }, renderAdditionalContent: function () { return _this._getFilterHeaderBar(); }, disableSticky: false },
                    React.createElement(Tabs_1.Tab, { name: Resources.PivotWorkloadsText, id: workloadsPivotItemKey }),
                    React.createElement(Tabs_1.Tab, { name: Resources.PivotServiceText, id: servicesPivotItemKey })),
                React.createElement("div", { className: "page-content page-content-top k8s-pivot-content" }, tabContent)));
        };
        KubeSummary.prototype._getSelectedItemPodsView = function () {
            var selectedItem = this.state.selectedItem;
            var selectedItemType = this.state.selectedItemType;
            // ToDo :: Currently for imageDetails type, the selected item will be undefined, hence adding below check. Remove this once we have data from imageService
            if (selectedItemType
                && this._selectedItemViewMap.hasOwnProperty(selectedItemType)) {
                return this._selectedItemViewMap[selectedItemType](selectedItem, this.state.selectedItemUid, this.state.selectedItemProperties);
            }
            return null;
        };
        KubeSummary.prototype._getWorkloadPodsViewComponent = function (item, defaultTypeString, selectedItemType, getStatusProps) {
            return (React.createElement(WorkloadDetails_1.WorkloadDetails, { item: item, parentKind: (item && item.kind) || defaultTypeString, itemTypeKey: selectedItemType, getStatusProps: getStatusProps, notifyViewChanged: this.props.onViewChanged }));
        };
        KubeSummary.prototype._getPodDetailsComponent = function (podUid, properties) {
            var selectionProperties = properties;
            return selectionProperties ? (React.createElement(PodsDetails_1.PodsDetails, { parentUid: selectionProperties.parentUid, serviceName: selectionProperties.serviceName, serviceSelector: selectionProperties.serviceSelector, selectedPodUid: podUid, notifyViewChanged: this.props.onViewChanged }))
                : null;
        };
        KubeSummary.prototype._selectTab = function (pivotItemKey) {
            var routeValues = __assign({}, queryString.parse(this._historyService.location.search));
            routeValues["view"] = pivotItemKey;
            this._historyService.replace({
                pathname: this._historyService.location.pathname,
                search: queryString.stringify(routeValues)
            });
            this.setState({ selectedPivotKey: pivotItemKey });
        };
        KubeSummary.prototype._populateObjectFinder = function () {
            var _this = this;
            this._objectFinder["replica-set" /* ReplicaSetKey */] = function (uid) { return KubeSummary._getFilteredFirstObject(_this._workloadsStore.getState().replicaSetList, uid); };
            this._objectFinder["stateful-set" /* StatefulSetKey */] = function (uid) { return KubeSummary._getFilteredFirstObject(_this._workloadsStore.getState().statefulSetList, uid); };
            this._objectFinder["daemon-set" /* DaemonSetKey */] = function (uid) { return KubeSummary._getFilteredFirstObject(_this._workloadsStore.getState().daemonSetList, uid); };
            this._objectFinder["orphan-pod" /* OrphanPodKey */] = function (uid) { return KubeSummary._getFilteredFirstObject(_this._podsStore.getState().podsList, uid); };
            this._objectFinder["pod-details" /* PodDetailsKey */] = function (uid) { return KubeSummary._getFilteredFirstObject(_this._podsStore.getState().podsList, uid); };
            this._objectFinder["service-item" /* ServiceItemKey */] = function (uid) {
                var filteredService = KubeSummary._getFilteredFirstObject(_this._servicesStore.getState().serviceList, uid);
                return filteredService ? ServiceUtils_1.getServiceItems([filteredService])[0] : undefined;
            };
        };
        KubeSummary._getFilteredFirstObject = function (itemList, uid) {
            var filteredItems = ((itemList || {}).items || []).filter(function (r) { return r.metadata.uid === uid; });
            return filteredItems && filteredItems.length > 0 ? filteredItems[0] : undefined;
        };
        KubeSummary.prototype._getFilterHeaderBar = function () {
            return (React.createElement(React.Fragment, null,
                React.createElement(ConditionalChildren_1.ConditionalChildren, { renderChildren: !this.state.selectedPivotKey || this.state.selectedPivotKey === workloadsPivotItemKey },
                    React.createElement(HeaderCommandBar_1.HeaderCommandBarWithFilter, { filter: this.state.workloadsFilter, filterToggled: workloadsFilterToggled, items: [] })),
                React.createElement(ConditionalChildren_1.ConditionalChildren, { renderChildren: this.state.selectedPivotKey === servicesPivotItemKey },
                    React.createElement(HeaderCommandBar_1.HeaderCommandBarWithFilter, { filter: this.state.svcFilter, filterToggled: servicesFilterToggled, items: [] }))));
        };
        KubeSummary.prototype._getZeroData = function () {
            return KubeZeroData_1.KubeZeroData.getDefaultZeroData();
        };
        KubeSummary.prototype._initializeFactorySettings = function () {
            KubeFactory_1.KubeFactory.setImageService(this.props.imageService);
            KubeFactory_1.KubeFactory.setKubeService(this.props.kubeService);
            KubeConsumer_1.setContentReaderComponent(this.props.getContentReaderComponent);
            KubeFactory_1.KubeFactory.setTelemetryService(this.props.telemetryService);
            KubeFactory_1.KubeFactory.setImageLocation(this.props.getImageLocation);
        };
        return KubeSummary;
    }(React.Component));
    exports.KubeSummary = KubeSummary;
});
